export default "__VITE_ASSET__6abd9bdd__"